import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEditDocuments(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-documents',
    alias: 'factoryEditDocuments',
    loader: i18nLoader,
  });
}
